import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Button, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import PropertyList from "../../features/manageCustomers/propertyList";
import {
  useLazyGetCustomerByIdQuery,
  useUpdateCustomerMutation,
} from "../../services/customer";
import { showError, showToast } from "../../constants/toasts";
import { Customer } from "../../types/General";
import CompanyDocumentation from "../../features/manageCustomers/CustomerDocs";
import { USER_STATUS } from "../../utils/enums";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import Loader from "../../constants/Loader";
import RejectedReasonDetailModal from "../../Modals/rejectedReasonDetail";
import ViewDocModal from "../../Modals/viewDocModal";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCustomerDetail = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const [getCustomerById] = useLazyGetCustomerByIdQuery();
  const [updateCustomer] = useUpdateCustomerMutation();
  const [selectedReasonType, setSelectedReasonType] = useState("");

  const [rejectionRsn, setRejectionRsn] = useState("");

  const [loading, setLoading] = useState(false);
  const [CustomerDetail, setCustomerDetail] = useState<Customer | null>(null);

  const [valueTabs, setValueTabs] = React.useState(0);
  const [valueTabs2, setValueTabs2] = React.useState(0);
  const [type, setType] = React.useState("");
  const [open, setOpen] = useState(false);
  const [openDocView, setOpenDocView] = useState(false);
  const [docViewImage, setDocViewImage] = useState("");
  const [reject, setReject] = useState(false);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const handleChangeStatus = async (status: number) => {
    try {
      const body =
        status == 1
          ? {
              status,
              userId: id,
            }
          : {
              status,
              userId: id,
              rejectReason: rejectionRsn,
              rejectType: Number(selectedReasonType),
            };

      const response = await updateCustomer({ ...body }).unwrap();
      if (response?.statusCode === 200) {
        showToast(
          status === USER_STATUS.APPROVED
            ? "Customer approved successfully"
            : "Customer rejected successfully"
        );

        navigate(-1);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      console.log(error);
    }
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const getData = async (id: string) => {
    setLoading(true);
    try {
      const response = await getCustomerById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setCustomerDetail(response?.data || null);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, []);

  return (
    <>
      <MainContainer>
        <Loader isLoading={loading} />
        <div className="main_title">
          <h1>Customer Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-customers")}>
              Manage Customers
            </span>{" "}
            - Customer Detail
          </p>
        </div>

        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="General Details" {...a11yProps(0)} />
                <Tab label="Property Details" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </div>
        </div>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Personal Details</h2>
            </div>
            <div className="gap_p">
              <div className="vew_img w_100">
                <h6>Image</h6>
                <figure>
                  <img
                    alt="user"
                    src={
                      CustomerDetail?.image ||
                      "/static/images/user_placeholder.png"
                    }
                  />
                </figure>
              </div>
              <div className="w_33">
                <h6>Name</h6>
                <p>{CustomerDetail?.fullName || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Email Id</h6>
                <p>{CustomerDetail?.email || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Phone Number</h6>
                <p>
                  {CustomerDetail?.phone
                    ? CustomerDetail?.countryCode + " " + CustomerDetail?.phone
                    : "-"}
                </p>
              </div>
              <div className="w_33">
                <h6>Address</h6>
                <p>{CustomerDetail?.address || "-"}</p>
              </div>
              <div className="w_33">
                <h6>City</h6>
                <p>{CustomerDetail?.city || "-"}</p>
              </div>

              <div className="w_33">
                <h6>Country</h6>
                <p>{CustomerDetail?.country || "-"}</p>
              </div>
              {/* <div className="w_33">
                <h6>Zip Code</h6>
                <p>98765</p>
              </div> */}
            </div>
          </div>
          <CompanyDocumentation
            userId={id || ""}
            setValueTabs={setValueTabs2}
            view={true}
            setOpenDocView={setOpenDocView}
            setDocViewImage={setDocViewImage}
          />
          {CustomerDetail?.status === USER_STATUS.PENDING ? (
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setType("approve");
                  setOpen(true);
                }}
              >
                Approve
              </Button>
              <Button
                className="btn btn_danger"
                onClick={() => {
                  setType("reject");
                  setReject(true);
                }}
              >
                Reject
              </Button>
            </div>
          ) : CustomerDetail?.status === USER_STATUS.REJECTED ? (
            <div className="rejectionDiv">
              <h3>Rejection Reason</h3>
              <p>{CustomerDetail?.rejectReason || ""}</p>
            </div>
          ) : null}
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="cards">
            <PropertyList />
          </div>
        </CustomTabPanel>
      </MainContainer>

      <ConfirmationModal
        text={`Are you sure to ${
          type === "approve" ? "approve" : "reject"
        } this customer`}
        openModal={open}
        setOpenModal={setOpen}
        handleSubmit={() =>
          handleChangeStatus(
            type === "approve" ? USER_STATUS.APPROVED : USER_STATUS.REJECTED
          )
        }
      />
      <RejectedReasonDetailModal
        open={reject}
        onClose={() => setReject(false)}
        setOpen={setReject}
        setSelectedReasonType={setSelectedReasonType}
        selectedReasonType={selectedReasonType}
        rejectionRsn={rejectionRsn}
        handleSubmit={() =>
          handleChangeStatus(
            type === "reject" ? USER_STATUS.REJECTED : USER_STATUS.APPROVED
          )
        }
        setRejectionRsn={setRejectionRsn}
      />
      <ViewDocModal
        open={openDocView}
        onClose={() => setOpenDocView(false)}
        imageUrl={docViewImage || ""}
      />
    </>
  );
};

export default ManageCustomerDetail;
